import { NgModule } from '@angular/core';
import { GlobalMenuComponent } from './global-menu/global-menu.component';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatBadgeModule} from '@angular/material/badge';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
// import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [
    GlobalMenuComponent,
    MainMenuComponent
  ],
  imports: [
    MatIconModule,MatListModule,CommonModule,RouterModule,MatToolbarModule,
    MatTooltipModule,MatBadgeModule,MatButtonModule,
    MatSelectModule,FormsModule, MatRadioModule,
    // TooltipModule.forRoot(),
    TranslateModule.forRoot()
  ],
  exports: [
    GlobalMenuComponent, MainMenuComponent
  ]
})
export class GlobalMenuModule { }
